<template>
  <div class="py-video-container">
    <!-- 状态栏 -->
    <!-- <div class="status-bar">
      <div>9:41</div>
      <div class="status-right">
        <div class="status-icon"></div>
        <div class="status-icon"></div>
        <div class="status-icon battery"></div>
      </div>
    </div> -->
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div class="back-btn" @click="goBack">
        <i class="el-icon-arrow-left back-icon"></i>
      </div>
      <div class="nav-title" style="margin-right: 15px;">文案配音</div>
      <div class="nav-actions">
        <i class=" action-icon"></i>
        <i class=" action-icon"></i>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="mains">
        <div class="section-title">广告文案，短视频等一键配音</div>
        <!-- 文案展示区域 -->
        <div class="script-section">
          <div class="script-header">
            <i class="el-icon-edit script-icon"></i>
            <input
              v-model="scriptTitle"
              placeholder="请输入标题"
              class="script-title-input"
            />
          </div>
          <div class="script-content">
            <textarea
              v-model="scriptText"
              placeholder="请输入您需要配音的文案，至少15个字。"
              class="script-textarea"
              minlength="15"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="section-content">
        <!-- 声音选择区域 -->
        <div class="voice-section">
          <!-- <div class="section-title">选择声音</div> -->
          <div class="voice-list">
            <div
              class="voice-item"
              :class="{
                active: selectedVoice == voice.id,
                playing: playingUrl == voice.audioSrc,
              }"
              @click="selectVoice(voice.audioSrc, voice.id)"
              v-for="voice in selectVoiceOptions"
              :key="voice.id"
            >
              <div class="voice-avatar">
                <img :src="voice.icon" alt="声音1" />
                <div
                  v-if="playingUrl == voice.audioSrc"
                  class="playing-indicator"
                >
                  <span class="playing-wave"></span>
                  <span class="playing-wave"></span>
                  <span class="playing-wave"></span>
                </div>
              </div>
              <div class="voice-name">
                {{ voice.name }}
                <span v-if="playingUrl == voice.audioSrc" class="playing-text"
                  >播放中</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 风格选择区域 -->
        <div class="style-section">
          <!-- <div class="section-title">选择风格</div> -->
          <div class="style-list">
            <!-- 预设风格选项 -->
            <div
              class="style-item"
              :class="{
                active: selectedStyle == style.id,
                playing: playingUrl == style.url,
              }"
              @click="selectStyle(style.audioSrc, style.id)"
              v-for="style in selectStyleOptions"
              :key="style.id"
            >
              <i
                v-if="playingUrl != style.url"
                class="el-icon-video-play play-icon"
              ></i>
              <div v-else class="playing-indicator-mini">
                <span class="playing-wave"></span>
                <span class="playing-wave"></span>
                <span class="playing-wave"></span>
              </div>
              <span class="style-name">
                {{ style.name }}
                <span v-if="playingUrl == style.url" class="playing-text"
                  >播放中</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 生成记录按钮 -->
    <div class="bottom-btn-section">
      <div class="record-btn" @click="toRecords('2')">
        生成记录
      </div>
      <el-button type="primary" class="generate-btn" @click="generateAudio" :loading="isLoading"
        >{{ isLoading ? '生成中...' : '生成音频' }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { anchorListVoiceModel, anchorListWorkTemplate, anchorVideoDubbing } from "@/api/video";
export default {
  name: "PyVideo",
  data() {
    return {
      selectedVoice: 0, // 默认选中第一个声音
      selectedStyle: 0, // 默认选中第一个风格
      scriptTitle: "", // 可输入的标题
      scriptText: "",
      selectStyleOptions: [],
      selectVoiceOptions: [],
      voiceId: "",
      styleId: "",
      isRecording: false, // 录音状态
      mediaRecorder: null, // 录音器实例
      audioChunks: [], // 音频数据块
      audioBlob: null, // 录音 Blob
      audioUrl: "", // 录音 URL
      audioPlayer: null, // 音频播放器实例
      playingUrl: "", // 当前播放的音频URL
      isLoading: false, // 加载状态
    };
  },
  created() {
    this.getVoiceModel();
    this.getWorkTemplate();
  },
  methods: {
    async generateAudio() {
      if (!this.scriptText) {
        this.$message.warning('请输入文案内容');
        return;
      }
      if (!this.voiceId) {
        this.$message.warning('请选择声音');
        return;
      }
      if (!this.styleId) {
        this.$message.warning('请选择风格');
        return;
      }
      
      this.isLoading = true;
      
      try {
        const userId = localStorage.getItem("userMes") ? (eval('(' + localStorage.getItem("userMes") + ')').phone) : "";
        const data = {
          userId: userId,
          text: this.scriptText,
          voiceId: this.voiceId,
          bgmId: this.styleId,
          name: this.scriptTitle,
        };
        
        console.log('生成音频参数:', data);
        
        const res = await anchorVideoDubbing(data);
        console.log('生成音频响应:', res);
        
        if (res.data.code === 200) {
          this.$message.success('音频生成成功');
          this.toRecords('2');
        } else {
          this.$message.error(res.data.message || '音频生成失败');
        }
      } catch (error) {
        console.error('生成音频失败:', error);
        this.$message.error('音频生成失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * 跳转到记录页面
     * 
     * @param {string} status - 记录类型状态参数
     */
    toRecords(status) {
      this.$router.push({
        name: "records",
        query: {
          type: status,
        },
      });
    },
    async getVoiceModel() {
      try {
        const res = await anchorListVoiceModel();
        console.log(res, "---res---");
        if (res.data.code === 200) {
          this.selectVoiceOptions = res.data.data.map((item) => ({
            name: item.name,
            audioSrc: item.url,
            id: item.id,
            code: item.code,
            icon: item.icon,
          }));
        }
      } catch (error) {
        console.error("查询配音员失败:", error);
      }
    },
    async getWorkTemplate() {
      try {
        const res = await anchorListWorkTemplate();
        console.log(res, "---res-151--");
        if (res.data.code === 200) {
          this.selectStyleOptions = res.data.data.map((item) => ({
            name: item.name,
            audioSrc: item.url,
            id: item.id,
            code: item.code,
          }));
        }
      } catch (error) {
        console.error("查询背景音乐失败:", error);
      }
    },
    goBack() {
      this.$router.back();
    },
    selectVoice(audioSrc, id) {
      console.log(audioSrc, id, "---172---");
      this.selectedVoice = id;
      this.voiceId = id;
      if (audioSrc) {
        this.playAudio(audioSrc);
      }
    },
    selectStyle(audioSrc, id) {
      console.log(audioSrc, id, "---184---");
      this.selectedStyle = id;
      this.styleId = id;
      if (audioSrc) {
        this.playAudio(audioSrc);
      }
    },
    async toggleRecording() {
      if (this.isRecording) {
        this.stopRecording();
      } else {
        await this.startRecording();
      }
    },
    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          this.audioBlob = new Blob(this.audioChunks, { type: "audio/wav" });
          this.audioUrl = URL.createObjectURL(this.audioBlob);
          this.$message.success("录音完成");

          stream.getTracks().forEach((track) => track.stop());
        };

        this.mediaRecorder.start();
        this.isRecording = true;
        this.$message.info("开始录音...");
      } catch (error) {
        console.error("录音失败:", error);
        this.$message.error("无法访问麦克风，请检查权限设置");
      }
    },
    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },
    deleteRecord() {
      this.audioBlob = null;
      this.audioUrl = "";
      this.audioChunks = [];
      this.$message.success("录音已删除");
    },
    playRecord() {
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.play();
      }
    },
    playAudio(src) {
      if (!src) {
        this.$message.warning("暂无音频资源");
        return;
      }
      if (this.audioPlayer) {
        this.audioPlayer.pause();
        this.audioPlayer = null;
      }
      this.playingUrl = src;
      this.audioPlayer = new Audio(src);
      this.audioPlayer
        .play()
        .then(() => {
          console.log("音频播放成功:", src);
        })
        .catch((error) => {
          console.error("音频播放失败:", error);
          if (error.name === "NotSupportedError") {
            this.$message.error("不支持的音频格式");
          } else if (error.name === "AbortError") {
            this.$message.warning("播放被中断");
          } else {
            this.$message.error("音频播放失败: " + error.message);
          }
          this.playingUrl = "";
        });
      this.audioPlayer.onended = () => {
        console.log("音频播放结束");
        this.playingUrl = "";
        this.audioPlayer = null;
      };
      this.audioPlayer.onerror = (event) => {
        console.error("音频播放错误:", event);
        const error = event.target.error;
        if (error) {
          console.error("错误代码:", error.code);
          console.error("错误消息:", error.message);
        }
        this.playingUrl = "";
        this.audioPlayer = null;
        this.$message.error("音频播放失败，请检查音频文件");
      };
    },
  },
  beforeDestroy() {
    if (this.isRecording && this.mediaRecorder) {
      this.mediaRecorder.stop();
      this.mediaRecorder = null;
    }
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer.src = '';
      this.audioPlayer = null;
    }
    if (this.audioUrl) {
      URL.revokeObjectURL(this.audioUrl);
      this.audioUrl = '';
    }
    this.playingUrl = '';
    this.audioChunks = [];
    this.audioBlob = null;
  },
};
</script>

<style scoped>
/* 全局样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.py-video-container {
  display: flex;
  flex-direction: column;
  height: 100vh;

  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  background: #fff !important;
}

/* 顶部导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  background-color: #bcdeff;
}

.back-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.back-icon {
  font-size: 18px;
  color: #000;
}

.nav-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action-icon {
  font-size: 18px;
  color: #000;
  cursor: pointer;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  /* padding: 16px; */
  overflow-y: auto;
  /* background-color: #e6f2ff; */
}

.mains {
  background: linear-gradient(180deg, #bcdeff 0%, #ffffff 100%);
  padding: 8px;
}

/* 文案展示区域 */
.script-section {
  border-radius: 12px 12px 0 0;
  margin-bottom: 24px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
  /* padding: 16px; */
  margin: 16px 16px 0 16px;
  background: rgba(255, 255, 255, 0.7);
  padding: 8px;
}

.script-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.script-icon {
  color: #409eff;
  font-size: 16px;
}

.script-title-input {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  border: none;
  outline: none;
  flex: 1;
  padding: 4px 0;
  background: transparent;
}

.script-title-input::placeholder {
  color: #909399;
}

.script-content {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  text-align: justify;
  width: 100%;
}

.script-textarea {
  width: 100%;
  border: none;
  resize: none;
  font-size: 15px;
  color: #303133;
  line-height: 1.6;
  min-height: 120px;
  outline: none;
}

.script-textarea::placeholder {
  color: #909399;
}

.section-content {
  width: 100%;
  /* height: 100%; */
  background-color: #ffffff;
  border-radius: 0px 0px 12px 12px;
  padding: 100px 16px 16px 16px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); */
  margin-bottom: 24px;
}

/* 声音选择区域 */
.voice-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin: 16px;
  padding-left: 4px;
  text-align: justify;
}

.voice-list {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.voice-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 88px;
  background: #ecf1f6;
  border-radius: 32rpx;
}

.voice-item:hover {
  background-color: #f0f8ff;
}

.voice-item.active {
  background: #c3ddff;
  border-radius: 32rpx;
}

.voice-item.playing {
  background: #e6f7ff;
  border: 2px solid #409eff;
}

.playing-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.playing-indicator-mini {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}

.playing-wave {
  width: 3px;
  height: 12px;
  background: #409eff;
  border-radius: 2px;
  animation: wave 1s ease-in-out infinite;
}

.playing-wave:nth-child(1) {
  animation-delay: 0s;
}

.playing-wave:nth-child(2) {
  animation-delay: 0.2s;
}

.playing-wave:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes wave {
  0%,
  100% {
    height: 8px;
  }
  50% {
    height: 16px;
  }
}

.playing-text {
  font-size: 12px;
  color: #409eff;
  margin-left: 4px;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.voice-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
}

.voice-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.empty-avatar {
  color: #909399;
  font-size: 28px;
}

.voice-name {
  font-size: 14px;
  color: #303133;
  text-align: center;
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 400;
}

/* 风格选择区域 */
.style-section {
  margin-bottom: 24px;
}

.style-list {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  flex-wrap: nowrap;
  padding-left: 16px;
}

.style-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 20px;
  background: #ecf1f6;
  border-radius: 32rpx;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  width: 200px;
  height: 60px;
  position: relative;
  margin-right: 20px;
}

.style-item:hover {
  /* border-color: #409eff; */
  background-color: #ecf5ff;
  color: rgba(0, 0, 0, 0.85);
}

.style-item.active {
  background: #c3ddff;
  border-radius: 32rpx;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 600;
}

.play-icon {
  font-size: 30px;
  color: #409eff;
  cursor: pointer;
  position: absolute;
  top: 15px;
  left: 0%;
  transform: translateX(-50%);
}

.style-name {
  color: #303133;
}

.style-item.active .style-name {
  color: #409eff;
}

/* 生成记录按钮 */
.record-btn {
  text-align: center;
  color: #409eff;
  font-size: 14px;
  padding: 12px 16px;
  cursor: pointer;
  background-color: #fff;
}

.record-btn:hover {
  text-decoration: underline;
}

/* 底部操作栏 */
.bottom-bar {
  padding: 16px;
  background-color: #ffffff;
  /* box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08); */
}

.generate-btn {
  width: 100%;
  height: 48px;
  font-size: 18px;
  border-radius: 24px;
  background-color: #409eff;
  border: none;
  font-weight: 500;
  color: #ffffff;
  /* box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3); */
  transition: all 0.3s ease;
}

.generate-btn:hover {
  background-color: #66b1ff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

/* 滚动条样式 */
.voice-list::-webkit-scrollbar {
  height: 4px;
}

.voice-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.voice-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.voice-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 适配移动端 */
@media (max-width: 375px) {
  .main-content {
    padding: 12px;
  }

  .voice-item {
    min-width: 80px;
  }

  .voice-avatar {
    width: 56px;
    height: 56px;
  }
}

/* 底部生成按钮 */
.bottom-btn-section {
  padding: 0px 20px 16px 20px;
  background-color: #ffffff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.05);
}
</style>
